module.exports = __webpack_public_path__ + "img/head_logo_zj.a6b4c395.png";